var React = require('react');

function QuoteLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"bff0b7c5-3979-4f43-a547-a9d683558e8d","data-name":"Path 5482","d":"M15.43,7.28C9.45,9.39,7.18,14,7.18,20.72h9V37.23H0V21.88C0,9.56,5.74,2.68,15.32,0Zm24.84,0C34.29,9.39,32,14,32,20.72h9V37.23H24.84V21.88C24.84,9.56,30.58,2.68,40.16,0Z","transform":"translate(0 0)"}));
}

QuoteLeft.defaultProps = {"id":"af245448-1d56-4b2c-b9fe-57c1515a973e","data-name":"Layer 1","viewBox":"0 0 41 37.23","width":"100%","height":"100%"};

module.exports = QuoteLeft;

QuoteLeft.default = QuoteLeft;
